import React from 'react';

import { retailLabel } from './messages';

// Component
import { PriceLabel } from './PriceLabel';

type RetailProps = {
    currency: string;
    showLabel?: boolean | null;
    price: number;
    quantityDisplay?: string | null;
    showPriceVariability?: boolean | null;
};

export const Retail: React.FC<RetailProps> = ({
    currency,
    price,
    showLabel,
    quantityDisplay,
    showPriceVariability,
}) => {
    return (
        <PriceLabel
            price={price}
            label={showLabel ? retailLabel : ''}
            quantityDisplay={quantityDisplay}
            currency={currency}
            showPriceVariability={showPriceVariability}
        />
    );
};

Retail.defaultProps = {
    showLabel: false,
    showPriceVariability: false,
};
